import { iconFactory } from '../iconFactory'

export const LocationOutline = iconFactory(
  'LocationOutline',
  ({ fill }) => (
    <>
      <path
        d="M7.99998 1.33337C5.41998 1.33337 3.33331 3.42004 3.33331 6.00004C3.33331 9.50004 7.99998 14.6667 7.99998 14.6667C7.99998 14.6667 12.6666 9.50004 12.6666 6.00004C12.6666 3.42004 10.58 1.33337 7.99998 1.33337ZM4.66665 6.00004C4.66665 4.16004 6.15998 2.66671 7.99998 2.66671C9.83998 2.66671 11.3333 4.16004 11.3333 6.00004C11.3333 7.92004 9.41331 10.7934 7.99998 12.5867C6.61331 10.8067 4.66665 7.90004 4.66665 6.00004Z"
        fill={fill}
      />
      <path
        d="M7.99998 7.66671C8.92045 7.66671 9.66665 6.92052 9.66665 6.00004C9.66665 5.07957 8.92045 4.33337 7.99998 4.33337C7.07951 4.33337 6.33331 5.07957 6.33331 6.00004C6.33331 6.92052 7.07951 7.66671 7.99998 7.66671Z"
        fill={fill}
      />
    </>
  ),
  { viewBox: '0 0 16 16', height: '16px', width: '16px' },
)
